import { render } from "./p-phone-number.vue?vue&type=template&id=34d9565c&scoped=true"
import script from "./p-phone-number.vue?vue&type=script&lang=js"
export * from "./p-phone-number.vue?vue&type=script&lang=js"

import "./p-phone-number.vue?vue&type=style&index=0&id=34d9565c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d9565c"]])

export default __exports__